<p-treeTable
  [value]="value()"
  [columns]="columns()"
  [scrollable]="true"
  [scrollHeight]="height()"
  [frozenColumns]="frozenColumns()"
  [frozenWidth]="frozenColumnsWidth()"
  (onNodeExpand)="expandRow.emit($event.node)"
  (onNodeCollapse)="collapseRow.emit($event.node)"
>
  <ng-template
    pTemplate="header"
    let-columns
  >
    <tr class="bg-transparent">
      @for (col of columns; track col.field) {
        <th
          [class]="col.class"
          class="bg-transparent text-neutral-500 whitespace-nowrap"
        >
          {{ col.header }}
        </th>
      }
    </tr>
  </ng-template>

  <ng-template
    pTemplate="body"
    let-rowNode
    let-rowData="rowData"
    let-columns="columns"
  >
    <tr [ttRow]="rowNode">
      @for (col of columns; track col.field) {
        <td
          [class]="col.class"
          [class.py-2]="expandableFields().includes(col.field) && !!rowData[col.field]"
          class="text-sm"
        >
          <div class="flex items-center">
            @if (expandableFields().includes(col.field) && !!rowData[col.field]) {
              <p-treeTableToggler [rowNode]="rowNode" />
            }

            @if (col.template) {
              <ng-container
                [ngTemplateOutlet]="col.template"
                [ngTemplateOutletContext]="{ $implicit: rowData, rowNode }"
              />
            } @else {
              <span
                [pTooltip]="rowData[col.field]"
                class="whitespace-nowrap truncate"
                tooltipStyleClass="text-xs"
              >
                {{ rowData[col.field] }}
              </span>
            }
          </div>
        </td>
      }
    </tr>
  </ng-template>
  @if (frozenColumns().length) {
    <ng-template
      pTemplate="frozenbody"
      let-rowNode
      let-rowData="rowData"
      let-columns="columns"
    >
      <tr [ttRow]="rowNode">
        @for (col of columns; track col.field) {
          <td
            [class]="col.class"
            [class.py-2]="expandableFields().includes(col.field) && !!rowData[col.field]"
            class="text-sm"
          >
            <div class="flex items-center">
              @if (expandableFields().includes(col.field) && !!rowData[col.field]) {
                <p-treeTableToggler [rowNode]="rowNode" />
              }

              @if (col.template) {
                <ng-container
                  [ngTemplateOutlet]="col.template"
                  [ngTemplateOutletContext]="{ $implicit: rowData, rowNode }"
                />
              } @else {
                <span
                  [pTooltip]="rowData[col.field]"
                  class="whitespace-nowrap truncate"
                  tooltipStyleClass="text-xs"
                >
                  {{ rowData[col.field] }}
                </span>
              }
            </div>
          </td>
        }
      </tr>
    </ng-template>
  }
  <ng-template pTemplate="emptymessage">
    <flx-empty-infobox [message]="emptyMessage()"></flx-empty-infobox>
  </ng-template>
</p-treeTable>
